import { BasicModal } from '~components/index';

interface Props {
  onHide: () => void;
}

const ReleasesModal = ({ onHide }: Props) => (
  <BasicModal
    title="btns.releases"
    body={
      <>
        <div className="d-flex flex-column gap-2">
          <ul>
            <li>
              La modal de cambio de estado se añaden wrappers y permite los
              inputs select multiples.
            </li>
            <li>En la modal de extraccion se añade la columna texto plano.</li>
            <li>Se añaden wrappers en la modal de cambio de estado.</li>
            <li>
              En las listas de trabajo el filtro se mantiene al cambiar entre
              tabs.
            </li>
            <li>
              Ahora se permiten cargar multiples archivos en la modal de cambio
              de estado.
            </li>
            <li>
              Ahora en la modal de cambio de estado dependiendo de la cantidad
              de inputs muestra 1, 2 o 3 columnas de inputs
            </li>
            <li>
              Si el ambiente es rimac, la modal de añadir registro no es una
              tabla si no un formulario.
            </li>
            <li>
              En la ufca-encuesta ahora se consulta un endpoint para saber si se
              tiene fragmento de extraccion para añadirlo al icono de (?)
            </li>
            <li>Perfil del paciente con vista de trazabilidad.</li>
            <li>
              En FCI en el modulo de agendamiento se añade el campo
              nacionalidad.
            </li>
            <li>
              Se añade semaforo a la lista de trabajo de manera dinamica por
              columna.
            </li>
          </ul>
        </div>
        <div className="d-flex flex-column gap-2">
          <p>
            <b>Version:</b> 2.6.12
          </p>
          <p>
            <b>Rama:</b> {import.meta.env.VITE_RELEASE_BRANCH}
          </p>
          <p>
            <b>Fecha:</b> {import.meta.env.VITE_RELEASE_DATE}
          </p>
        </div>
      </>
    }
    onHide={onHide}
  />
);

export default ReleasesModal;
